module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/home/components/home-main-modal-detail-base/home-main-modal-detail-base.component.sass
// module id = ./src/app/modules/home/components/home-main-modal-detail-base/home-main-modal-detail-base.component.sass
// module chunks = main